// start:ng42.barrel
export * from './blank.component';
// end:ng42.barrel
